import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SettingSellProductOrganizer';

const getSettingSellProductOrganizerReducer = handleActions({
    [Actions.GetSettingSellProductOrganizerRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetSettingSellProductOrganizerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetSettingSellProductOrganizerRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearSettingSellProductOrganizer]: () => ({
        isFetching: false,
        errors: {},
        data: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSettingSellProductOrganizerReducer = handleActions({
    [Actions.UpdateSettingSellProductOrganizerRequested]: (state) => ({
        ...state,
        isFetching: true,
        updateSuccess: false,
    }),
    [Actions.UpdateSettingSellProductOrganizerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        updateSuccess: true,
    }),
    [Actions.UpdateSettingSellProductOrganizerRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        updateSuccess: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    updateSuccess: false,
});

export default combineReducers({
    get: getSettingSellProductOrganizerReducer,
    update: updateSettingSellProductOrganizerReducer,
});
